// Entry point for the build script in your package.json
import "./adminkit"
import "./libs"
import "./helper"
import "./controllers"
import "./datatables"
import "./feature"

document.addEventListener("DOMContentLoaded", () => {
  try {
    feather.replace();
    caller()
  }
  catch (e) {
    console.log('You might have made a typo with one of the feather icons');
    console.log(e);
  }
});

$(document).on('click', '#sign-out', function () {
  $.ajax({
    url: "/users/sign_out",
    method: "delete",
    headers: { "X-CSRF-Token": $("meta[name='csrf-token']").attr('content') },
    success: () => { window.location.reload() },
    error: () => { alert('Logout gagal') }
  })
})

$(document).off('click', '#add-item');
$(document).on('click', '#add-item', function () {
  $.ajax({
    url: "/ppic/planning_products/new",
    method: "get",
    dataType: "script",
    data: {
      'partial': 'add-item'
    }
  });
});

$(document).off('click', '.btn-deleted');
$(document).on('click', '.btn-deleted', function (e) {
  e.preventDefault();
  $(this).closest('tr').remove();

  $("#tbl-item tbody tr").each(function(index) {
    $(this).find("td:nth-child(1)").text(index + 1);
  });
});
